<template>
    <div class="header-hrom">
        <Icon type="ios-megaphone" size="20" />
        <span>
            {{}}
        </span>
    </div>
</template>
<script>
export default {
    
}
</script>

<style lang="scss">
    .header-hrom {
        width: 870px;
        height: 20px;
        border-radius: 5px;
        background-color: #191a23;
        display: inline-block;
        font-size: 12px;
        margin: 0 5px;
        
    }
</style>